import { render } from "./BodySection.vue?vue&type=template&id=7ae12679&scoped=true"
import script from "./BodySection.vue?vue&type=script&lang=js"
export * from "./BodySection.vue?vue&type=script&lang=js"

import "./BodySection.vue?vue&type=style&index=0&id=7ae12679&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae12679"]])

export default __exports__